import { PropertyType } from '../types';
import { formatCents } from './numberFormatter';

export const propertiesFormatter = (object: PropertyType, formatter: PropertyType): PropertyType => {
	const newObject = { ...object };
	Object.keys(object).map((key) => {
		switch (formatter[key]) {
			case 'value':
				newObject[key] = object[key];
				break;
			case 'cents':
				newObject[key] = formatCents(object[key]);
				break;

			default:
				newObject[key] = object[key];
				break;
		}
	});
	return newObject;
};
